import { Explorer100, Tree, Access220, Shell3218 } from '@react95/icons';
import { projects, projectGroups } from './projects';

const icons = { robotica: Tree, iot: Access220, software: Shell3218 };
export const portfolio = [{
  id: 'projects', label: 'Meu perfil e projetos',
  icon: <Explorer100 style={{ height: 20, width: 20 }} />,
  items: projectGroups.map((group) => {
    const Icon = icons[group.id];
    return {
      ...group, icon: <Icon style={{ height: 20, width: 20 }} />,
      items: Object.entries(projects).filter(([, project]) => project.category === group.id).map(([id, project]) => ({
        id, label: project.title, icon: <Icon style={{ height: 20, width: 20 }} />,
      })),
    };
  }),
}];
